import Tesseract from 'tesseract.js';
import type { MedicalExamIndicator } from '@/types';

interface OCRResult {
  text: string;
  indicators: MedicalExamIndicator[];
}

export async function recognizeImage(file: File): Promise<OCRResult> {
  const result = await Tesseract.recognize(
    file,
    'chi_sim+eng',
    {
      logger: m => console.log(m)
    }
  );

  const text = result.data.text;
  const indicators = parseMedicalText(text);

  return { text, indicators };
}

function parseMedicalText(text: string): MedicalExamIndicator[] {
  const indicators: MedicalExamIndicator[] = [];
  
  // Common medical indicators patterns
  const patterns = [
    { name: '尿酸', pattern: /尿酸[：:]\s*(\d+\.?\d*)\s*(?:μmol\/L|umol\/L)?/i, unit: 'μmol/L', normal: '208-428' },
    { name: '甘油三酯', pattern: /甘油三酯[：:]\s*(\d+\.?\d*)\s*(?:mmol\/L)?/i, unit: 'mmol/L', normal: '<1.7' },
    { name: '总胆固醇', pattern: /总胆固醇[：:]\s*(\d+\.?\d*)\s*(?:mmol\/L)?/i, unit: 'mmol/L', normal: '<5.2' },
    { name: '高密度脂蛋白', pattern: /高密度脂蛋白[：:]\s*(\d+\.?\d*)\s*(?:mmol\/L)?/i, unit: 'mmol/L', normal: '>1.0' },
    { name: '低密度脂蛋白', pattern: /低密度脂蛋白[：:]\s*(\d+\.?\d*)\s*(?:mmol\/L)?/i, unit: 'mmol/L', normal: '<3.4' },
    { name: '空腹血糖', pattern: /(?:空腹)?血糖[：:]\s*(\d+\.?\d*)\s*(?:mmol\/L)?/i, unit: 'mmol/L', normal: '3.9-6.1' },
    { name: '糖化血红蛋白', pattern: /糖化血红蛋白[：:]\s*(\d+\.?\d*)\s*(?:%)?/i, unit: '%', normal: '<6.5' },
    { name: '肌酐', pattern: /肌酐[：:]\s*(\d+\.?\d*)\s*(?:μmol\/L)?/i, unit: 'μmol/L', normal: '57-97' },
    { name: '谷丙转氨酶', pattern: /谷丙转氨酶|ALT[：:]\s*(\d+\.?\d*)\s*(?:U\/L)?/i, unit: 'U/L', normal: '<40' },
    { name: '谷草转氨酶', pattern: /谷草转氨酶|AST[：:]\s*(\d+\.?\d*)\s*(?:U\/L)?/i, unit: 'U/L', normal: '<40' },
    { name: '血红蛋白', pattern: /血红蛋白[：:]\s*(\d+\.?\d*)\s*(?:g\/L)?/i, unit: 'g/L', normal: '130-175' },
  ];

  for (const { name, pattern, unit, normal } of patterns) {
    const match = text.match(pattern);
    if (match) {
      indicators.push({
        recordId: 0, // Will be set when saving
        name,
        value: parseFloat(match[1]),
        unit,
        referenceRange: normal
      });
    }
  }

  return indicators;
}
